import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Box, ButtonDropdown, Container, Grid, Header, KeyValuePairs, SpaceBetween, Spinner, Tabs } from "@amzn/awsui-components-react";
import { getFlexicoTemplate, getFlexicoTransaction } from 'src/utilities/FlexicoAPIs';
const EmbedFlexicoParams = (props) => {
  const [transactionInfo, setTransactionInfo] = useState(null)
  const [params, setParams] = useState([])
  useEffect(() => {
    if(props.fileId == null){
      return
    }
    if(props.transactionInfo){
      getFlexicoTemplateInfo(props.transactionInfo)
    }else{
      getFlexicoTransaction(props.fileId, function onSuccess(result){
            getFlexicoTemplateInfo(result.data.getFlexicoTransaction)
          })
    }
    
  }, [props?.fileId])


  function getFlexicoTemplateInfo(transactionInfo){
    getFlexicoTemplate(transactionInfo.flexId, function onSuccess(flexicoInfo){
        const labelObject = flexicoInfo.data.getFlexicoTemplateRDS.parameters.reduce((acc, param) => {
          acc[param.label] = param;
          return acc;
        }, {});
        if(transactionInfo.plainParameters || transactionInfo.parameters){
        let parameters = JSON.parse(transactionInfo.plainParameters) || JSON.parse(transactionInfo.parameters)
        let paramObject = []
        Object.keys(parameters).forEach((key) => {
          if (labelObject[key]) {
            paramObject.push({
              'label': labelObject[key].display_name,
              'value': parameters[key]
            })
          }
        })
        setParams(paramObject)
      }
      setTransactionInfo(transactionInfo)
      })
  }

  return (<Container
    header={<Header
      variant="h3"
      description="Parameters chosen while execution"
    >
      Input
    </Header>} >
    <KeyValuePairs
      columns={3}
      items={params}
    />
  </Container>)

}

export default EmbedFlexicoParams;
